import { render } from "./Kanban.vue?vue&type=template&id=24dfe695"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"
script.render = render

export default script